export default {
  payChannel: 'Zahlungskanäle',
  cashierDesk: 'Kasse',
  billAddress: 'Rechnungsadresse',
  paySuccess: 'Zahlung erfolgreich',
  payError: 'Zahlung fehlgeschlagen',
  harvestAddress: 'Lieferadresse',
  orderAddress: 'Rechnungsadresse',
  selectAddress: 'Lieferadresse auswählen',
  addOrderAddress: 'Bitte fügen Sie zuerst die Rechnungsadresse hinzu',
  addSelectAddress: 'Bitte wählen Sie eine Lieferadresse aus',
  noAddress: 'Keine Lieferadresse verfügbar',
  holder: {
    inputPayPwd: 'Bitte legen Sie das Zahlungspasswort fest',
    returnExchange:
      'Zahlung nicht abgeschlossen. Rückgabe-/Umtauschanfrage kann nicht bearbeitet werden.',
  },
  transferTitle: 'Banküberweisung',
  changeAddress: 'Adresse ändern',
  editText: 'Bearbeiten',
  payWithbalance: 'Mit acbuy-Guthaben bezahlen',
  bankTransferRemittance: 'Banküberweisung',
  transferTips:
    '0 Servicegebühr bei acbuy für Überweisungen. Je höher der Bestellbetrag, desto mehr sparen Sie!',
  pay: 'Aufladeangebote',
  plsSetPsd: 'Bitte Zahlungspasswort festlegen',
  thirdPayTips: 'Zahlungen sind weltweit und in mehreren Währungen möglich',
  payProcessing: 'Zahlungsverarbeitung',
  payWaitingText: 'Bitte warten Sie 1-2 Minuten, das Ergebnis der Zahlung wird später angezeigt',
  coinpalTips:
    'Aufladungen von digitaler Währung (virtueller Währung) sind nicht erstattungsfähig und können nicht ausgezahlt werden. Wenn Sie damit einverstanden sind, fahren Sie bitte mit der Aufladung fort.',
  payStatusTips:
    'Nous n’avons pas encore reçu le résultat de votre paiement. Veuillez confirmer le statut de votre paiement.',
  payErrorStatusTips: 'Zahlung fehlgeschlagen. Bitte versuchen Sie eine andere Zahlungsmethode.',
  sepaTips:
    'SPEA-Einzahlungen sind nicht erstattungsfähig und können nicht ausgezahlt werden. Wenn Sie dies akzeptieren, können Sie Ihre Einzahlungen fortsetzen.',
}
